<template>
  <div>
    <el-row>
      <el-col class="filter-bar product-filter">
        <mq-layout :mq="$mq" class="container filter-bar__content">
          <el-col class="text-left" :span="isMobileLayout ? 12 : 6">
            <div class="padded d-flex">
              <span
                class="label__filter d-flex a-items-center mr-10"
                @click="filterClick"
              >
                <img
                  class="mr-10"
                  :src="images.filterMain.src"
                  style="height: 20px"
                />
                <span class="filter label text-left fs-16">{{ filterLabel }}</span>
              </span>
              <span
                v-show="filterCount > 0"
                class="label label__reset d-flex a-items-center fs-16"
                @click="reset"
              >
                {{ resetLabel }}
              </span>
            </div>
          </el-col>
          <el-col
            class="text-right pr-10"
            :span="isMobileLayout ? 12 : 6"
            :offset="isMobileLayout ? 0 : 12"
          >
            <div class="padded d-flex-inline a-items-center view-type">
              <div @click="chnageView('tuiles')" class="d-flex-inline a-items-center">
                <img
                  class="mr-5"
                  :src="images.filterIconOne.src"
                  
                  style="height: 20px"
                />
                <span
                  v-if="!isMobileLayout"
                  class="label label--emphasis ml-5 mr-20 fs-13"
                  @click="chnageView('tuiles')"
                  >{{ cardsViewLabel }}</span
                >
              </div>
              <div @click="chnageView('liste')" class="d-flex-inline a-items-center">
                <img
                  class="mr-5"
                  :src="images.filterListView.src"
                  style="height: 20px"
                />
                <span
                  v-if="!isMobileLayout"
                  class="label label--emphasis ml-5 fs-13"
                  >{{ listViewLabel }}</span
                >
              </div>
            </div>
          </el-col>
        </mq-layout>
      </el-col>
    </el-row>
    <el-row v-if="sortable">
      <el-col class="text-right">
        <div class="container">
          <i
            class="el-icon-printer mh-5"
            v-if="currentRouteName != 'providers'"
          ></i>
          <span
            class="label text-left pdf-download"
            v-if="currentRouteName != 'providers'"
            @click="downloadPdf()"
            >{{ printLabel }}</span
          >

          <el-select
            v-if="showFilter"
            v-model="sortSelectedValue"
            :placeholder="$t('common.filterBar.placeHolder')"
            :no-data-text="'empty.text'"
            @change="shortingBy"
          >
            <el-option
              v-for="item in $t('common.filterBar.sortOptions')"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          
        </div>
      </el-col>
    </el-row>
    <el-row v-if="currentRouteName == 'blogs'">
      <el-col class="text-right">
        <div class="container">
          <el-select
            v-if="showFilter"
            v-model="sortSelectedValue"
            :placeholder="$t('common.filterBar.placeHolder')"
            :no-data-text="'empty.text'"
            @change="shortingBy"
          >
            <el-option
              v-for="item in $t('common.filterBar.sortBlogOptions')"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";
import imgfilterListView from "@/assets/images/filter/filter-list-view.svg";
import imgfilterIconOne from "@/assets/images/filter/filter-icon-one.svg";
import imgfilterMain from "@/assets/images/filter/filter-main.svg";

export default {
  props: {
    filterCount: {
      type: Number,
      default: 0,
    },
    sortable: {
      type: Boolean,
      default: true,
    },
    showFilter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sortSelectedValue: "",
      images: {
        filterListView: {
          src: imgfilterListView,
        },
        filterIconOne: {
          src: imgfilterIconOne,
        },
        filterMain: {
          src: imgfilterMain,
        },
      },
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    formattedFilterCount() {
      return this.filterCount && this.filterCount > 0
        ? ` (${this.filterCount})`
        : "";
    },
    filterLabel() {
      return (
        this.$i18n.t("common.filterBar.label.filter") +
        this.formattedFilterCount
      );
    },
    resetLabel() {
      return this.$i18n.t("common.filterBar.label.reset");
    },
    sortLabel() {
      return this.$i18n.t("common.filterBar.label.sort");
    },
    printLabel() {
      return this.$i18n.t("common.filterBar.label.print");
    },
    listViewLabel() {
      return this.$i18n.t("common.filterBar.label.VueList");
    },
    cardsViewLabel() {
      return this.$i18n.t("common.filterBar.label.VueTuiles");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  methods: {
    reset() {
      this.$emit("emit-filter-reset");
    },
    filterClick() {
      this.$emit("emit-filter-click");
    },
    chnageView(viewType) {
      localStorage.setItem("viewType", viewType);
      this.$root.$emit("viewType", viewType);
    },
    downloadPdf() {
      // this.$root.$emit("viewType", "liste");
      this.$emit("emit-pdf-download");
    },
    shortingBy(){
      this.$emit("emit-shorting-change", this.sortSelectedValue);
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";
.logo {
  width: 100%;
  display: block;
}
.filter-bar {
  width: 100%;
  padding: 0.5rem 0;
  background-color: $color-background-area2;
}
.filter-bar__content {
  display: block;
}
.label {
  color: $color-on-background-area1;
}
.label__greyed {
  color: rgba(39, 36, 33, 0.33);
  line-height: normal;
}
.label__filter:hover {
  cursor: pointer;
}
.label__reset {
  color: $color-primary !important;
  padding-right: 0.4rem;
}
.label__reset:hover {
  color: $color-primary-light !important;
  cursor: pointer;
}
.label--emphasis {
  color: #333333 !important;
  font-family: 'ArialMT', 'Arial', sans-serif;
}
.padded {
  padding: 0% 4px 0% 4px;
}
.d-flex {
  display: flex;
}
.a-items-center {
  align-items: center;
}
.img--filter {
  @media screen and (min-width: $media-md) {
    width: 16px;
  }

  @media screen and (max-width: $media-md) {
    width: 14px;
  }
}
.el-icon-printer {
  font-size: 14px;
}
.el-select {
  & div {
    & input {
      border: 0px !important;
      font-family: "Futura ", "Futura", sans-serif;
      font-size: 12px;
      // text-align: right !important;
      // width: 160px;
      height: 26px;
      color: #a31c25;
    }
    & span {
      & span {
        & i {
          color: black !important;
          font-weight: 900;
        }
      }
    }
  }
}
.fs-16 {
  font-size: 16px !important;
}
.view-type {
  cursor: pointer;
}
.pdf-download {
  cursor: pointer;
}
.filter {
  font-family: "ArialMT", "Arial", sans-serif !important;
  font-size: 13px !important;
}
</style>
